import { Box, Diagram, Grid, ResponsiveContext, Stack, Text } from "grommet";
import { flatten, fromPairs } from "lodash";
import * as React from "react";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import ScrollContainer from "../components/ScrollContainer";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { TournamentMatchBlock } from "./TournamentMatchBlock";
import { getTournament, TournamentMatchViewModel, TournamentViewModel } from "./TournamentsStore";

const Unselectable = styled.div`
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;

    /*
      Introduced in IE 10.
      See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
    */
    -ms-user-select: none;
    user-select: none;
`;

const RenderRound = ({ round, totalRounds }) => {
    if (round == totalRounds) {
        return <Text style={{ fontWeight: "bold", textTransform: "uppercase" }}>Final</Text>;
    } else if (round == totalRounds - 1) {
        return <Text style={{ fontWeight: "bold", textTransform: "uppercase" }}>Semi-final</Text>;
    } else if (round == totalRounds - 2) {
        return <Text style={{ fontWeight: "bold", textTransform: "uppercase" }}>Quarter-final</Text>;
    } else {
        return <Text style={{ fontWeight: "bold", textTransform: "uppercase" }}>Round {round}</Text>;
    }
};

const TournamentBracket = ({ tournament, onClick }: { tournament: TournamentViewModel; onClick: (tournamentMatch: TournamentMatchViewModel) => any }) => {
    const [connections, setConnections] = React.useState([] as any[]);
    const size = React.useContext(ResponsiveContext);
    const [isLoading, setIsLoading] = React.useState(true);
    let diagramRef = useRef(null);

    React.useEffect(() => {
        let matches = flatten(tournament.bracket?.rounds?.map((round) => round.matches) || []);
        if (matches.length > 0) {
            let matchRounds = fromPairs(matches.map((match) => [match.tournamentMatchID, match.roundID]));
            let winnerMatches = matches.filter((match) => match.nextTournamentMatchID != 0);

            let winnerConnections = winnerMatches.map((match, i) => ({
                fromTarget: "match" + match.tournamentMatchID.toString(),
                toTarget: "match" + match.nextTournamentMatchID.toString(),
                thickness: "xsmall",
                color: "background-front",
                type: "rectilinear",
                anchor: matchRounds[match.tournamentMatchID] == matchRounds[match.nextTournamentMatchID] ? "vertical" : "horizontal",
            }));

            setConnections([
                ...winnerConnections,
                // ...matches
                //     .filter((match) => match.loserTournamentMatchID != 0)
                //     .map((match, i) => ({
                //         fromTarget: "match" + match.tournamentMatchID.toString(),
                //         toTarget: "match" + match.loserTournamentMatchID.toString(),
                //         thickness: "xsmall",
                //         color: "red",
                //         type: "curved",
                //         anchor: "center",
                //     })),
            ]);

            setIsLoading(false);
        }
    }, [tournament, size]);

    const BracketGridProps =
        size == "small"
            ? { rows: ["auto"], columns: new Array(tournament.bracket?.rounds?.length || 0).fill(size) }
            : {
                  rows: ["auto"],
                  columns: new Array(tournament.bracket?.rounds?.length || 0).fill("auto"),
                  //   columns: new Array(tournament.bracket.rounds.length).fill(tournament.bracket.rounds.length >= 4 ? "18%" : tournament.bracket.rounds.length > 2 ? "25%" : "45%"),
              };

    return (
        <SkeletonWrapper loading={isLoading}>
            <Unselectable>
                <Stack guidingChild={1}>
                    <Diagram id="bracketDiagram" connections={connections} />
                    <Grid {...BracketGridProps} gap="small">
                        {tournament?.bracket?.rounds?.map((round, index) => (
                            <Box key={"r" + index}>
                                <RenderRound round={round.roundID} totalRounds={tournament.bracket?.rounds?.length || 0}></RenderRound>
                                <Box pad="small" gap="small" fill justify="evenly">
                                    {round.matches
                                        .filter((m) => !m.loserBracket)
                                        .map((match, i) => (
                                            <TournamentMatchBlock key={"m" + i} tournamentMatch={match} showOptionalMessage={round.matchCount != 1} onClick={onClick}></TournamentMatchBlock>
                                        ))}
                                </Box>
                            </Box>
                        ))}
                        {tournament?.bracket?.rounds?.map((round, index) => (
                            <Box key={"rl" + index}>
                                <Box pad="small" gap="small" fill justify="evenly">
                                    {round.matches
                                        .filter((m) => m.loserBracket)
                                        .map((match, i) => (
                                            <TournamentMatchBlock key={"m" + i} tournamentMatch={match} showOptionalMessage={round.matchCount != 1} onClick={onClick}></TournamentMatchBlock>
                                        ))}
                                </Box>
                            </Box>
                        ))}
                    </Grid>
                </Stack>
            </Unselectable>
        </SkeletonWrapper>
    );
};

export default TournamentBracket;
